import { render } from "./vacard.vue?vue&type=template&id=6d2f7d64"
import script from "./vacard.vue?vue&type=script&lang=js"
export * from "./vacard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__